module.exports = __webpack_public_path__ + "img/1-1.d2082119.png";